import { useContext, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import { AppContext } from "../../context/AppContext";
import ApiService from "../../utils/apiServices";
import { rest_api_url } from "../../constants/urls";
import { restrictedPaths } from "../../utils/consts";
import { storeSelectedClient } from "../sidebar/utils";

export const CLIENT_SYNC_THROTTLE_MS = 15000;

const ClientSyncWatcher = () => {
  const { user } = useContext(AppContext);
  const history = useHistory();
  const userRef = useRef(user);

  useEffect(() => {
    userRef.current = user;
  }, [user]);

  useEffect(() => {
    const onStorage = (event) => {
      if (event.key !== "client-id") return;
      if (event.newValue && String(event.newValue) === String(userRef.current?.partner_id)) return;
      window.location.reload();
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);

  useEffect(() => {
    let lastCheck = 0;
    let inFlight = false;

    const check = () => {
      if (document.visibilityState !== "visible") return;
      if (restrictedPaths.includes(window.location.pathname)) return;
      const current = userRef.current?.partner_id;
      if (!current || inFlight) return;
      const now = Date.now();
      if (now - lastCheck < CLIENT_SYNC_THROTTLE_MS) return;
      lastCheck = now;
      inFlight = true;

      new Promise((resolve, reject) => {
        ApiService.get(rest_api_url.user_data, resolve, reject, true);
      })
        .then((fresh) => {
          inFlight = false;
          if (fresh?.partner_id && String(fresh.partner_id) !== String(userRef.current?.partner_id)) {
            storeSelectedClient({ id: fresh.partner_id });
            window.location.reload();
          }
        })
        .catch(() => {
          inFlight = false;
        });
    };

    window.addEventListener("focus", check);
    document.addEventListener("visibilitychange", check);
    const unlisten = history.listen(check);
    return () => {
      window.removeEventListener("focus", check);
      document.removeEventListener("visibilitychange", check);
      unlisten();
    };
  }, [history]);

  return null;
};

export default ClientSyncWatcher;
